<template>
    <div class="msgbox">
        <div id="captcha"></div>
	    <cube-button class="vercode-btn" :disabled="disabledCall"  type="button" @click="openDun">{{ showText }}</cube-button>
    </div>
</template>

<script>
import { getCallMsg } from 'api';
import { initNetEaseDun } from 'SaicUtil';
    export default {
        name:'getCallMsg',
        props: {
            phoneNumber: String,
        },
        data(){
          return {
              showText: '获取验证码',
              clickable: true,
              countdown: 60, //倒计时时间配置
              captchaIns: null, // 易盾实例
              verified: false, //是否已经验证过
              loadError: false,//易盾加载失败时
              loadNet: false, //易盾验证中
          }
        },
        computed:{
          disabledCall () {
              return !this.clickable || this.phoneNumber=='' || this.phoneNumber.length != 11 || this.loadNet
          }
        },
        mounted () {
            const _this = this;
            const dw = document.documentElement.offsetWidth || document.body.offsetWidth;
            const dwidth = dw >= 350?'320px':'220px'
            initNetEaseDun(() => {
                initNECaptcha({
                    captchaId: '9bf804b38df4489bb1cf95901e6f7679',
                    element: '#captcha',
                    mode: 'bind',
                    width: dwidth,
                    onVerify: _this.verify,
                }, function onload (instance) {
                    _this.captchaIns = instance
                }, function onerror (err) {
                    console.log(err)
                    _this.loadError = true
                })
            })
        },
        methods:{
            openDun () {
                if(this.disabledCall) {
                    return
                }
                if( this.loadError ){
                    this.$createDialog({
                        type: 'alert',
                        content: `验证码发送失败，请刷新页面重试`,
                        icon: 'cubeic-important'
                    }).show()
                    return
                }
                this.loadNet = true
                this.showText = '发送中...'
                this.captchaIns && this.captchaIns.verify()
            },
            verify (err, data) {
                if(err) return;
                // console.log(data)
                //this.verified = true
                this.getMsg(data.validate)
            },
            getMsg (validateParam) {
                const call = this.phoneNumber
                const _this = this
                var fd = new FormData()
                fd.append('timestamp', +new Date())
                fd.append('mobile', call)
                fd.append('operType', '2')
                fd.append('neCaptchaValidate', validateParam)
                fd.append('trick', '1')
                getCallMsg(fd).then(res => {
                    try{
                        _this.captchaIns && _this.captchaIns.refresh()
                        if(res.data && res.data.send === 'true'){
                            _this.countdownMethod()
                        }
                        if(res.err_resp){
                            _this.$createDialog({
                                type: 'alert',
                                content: `${res.err_resp.msg}`,
                                icon: 'cubeic-important'
                            }).show()
                            _this.showText = '获取验证码'
                        }
                        _this.loadNet = false
                    }catch(e){
                    	//TODO handle the exception
                    }
                })
            },
            countdownMethod () {
                const _this = this
                this.clickable = false
                let countDownNum = 60
                countDownNum--
                _this.showText = countDownNum
                const timer = setInterval(()=>{
                    countDownNum--
                    if(countDownNum == 0){
                        _this.showText = '获取验证码'
                        _this.clickable = true
                        clearInterval(timer)
                    }else{
                        _this.showText = countDownNum
                    }
                },1000)
                
            }
        }
        
    }
</script>

<style scoped lang="scss">
.msgbox {
    position: relative;
    // float: left;
}
</style>